const IMAGE_JPG = "image/jpg";
const IMAGE_JPEG = "image/jpeg";
const IMAGE_PNG = "image/png";
const IMAGE_BMP = "image/bmp";
const APPLICATION_PDF = "application/pdf";

export const AllowedFileTypes = [
  IMAGE_JPG,
  IMAGE_JPEG,
  IMAGE_PNG,
  IMAGE_BMP,
  APPLICATION_PDF
];

export const AllowedImageFileTypes = [
  IMAGE_JPG,
  IMAGE_JPEG,
  IMAGE_PNG,
  IMAGE_BMP
];

export const AllowedPDFFileTypes = [APPLICATION_PDF];

export const FileTypeToExtensionMapping = {
  "image/jpg": "jpg",
  "image/jpeg": "jpeg",
  "image/png": "png",
  "image/gif": "gif",
  "image/bmp": "bmp",
  "image/tiff": "tiff",
  "image/tif": "tiff",
  "application/pdf": "pdf"
};


